/** React Query cache key — keep in sync anywhere this integration is fetched. */
export const BUILDER_WHATSAPP_QUERY_KEY = ['builderWhatsapp'];

export function isBuilderWhatsappConfigured(data) {
  return (
    data?.is_api_key_configured === true || data?.is_pinggo_vendor_id_configured === true
  );
}
